import React from 'react';
import {
  IMarketplaceTilesProjectTimeline,
} from 'src/typings/marketplace';
import { translations } from 'src/constants/translations';
import { updateTranslatedField } from 'src/components/profileComponents/Marketplace/components/Filters/helpers';
import { BoxFormTextField } from 'src/components/profileComponents/FormTextField';
import { BoxFormAutocomplete } from 'src/components/profileComponents/FormAutocomplete';
import {
  GroupWrapperFiltersAction,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction';
import { useStyles as mainUseStyles } from 'src/components/profileComponents/Marketplace/components/Common/styles';
import { GroupWrapper } from 'src/components/profileComponents/Marketplace/components/GroupWrapper';
import {
  GroupWrapperCollapseState,
} from 'src/components/profileComponents/Marketplace/components/GroupWrapperActions/GroupWrapperFiltersAction/types';
import {
  IDevelopmentSpecificationPropChange,
} from 'src/components/profileComponents/Complexes/components/ProjectSpecification/types';
import { IComplexProperty, IMarketplaceProperty } from 'src/components/profileComponents/Marketplace/types';
import Box from '@mui/material/Box';
import {
  useStyles,
} from './styles';

interface Props {
  item: IMarketplaceTilesProjectTimeline;
  lang: string;
  complexPropertyOptions: IDevelopmentSpecificationPropChange<IComplexProperty>[];
  onChange: (item: IMarketplaceTilesProjectTimeline) => void,
}
export const TileProjectTimeline: React.FC<Props> = ({
  item, lang, complexPropertyOptions, onChange,
}) => {
  const styles = useStyles();
  const mainStyles = mainUseStyles();
  const [collapseState, setCollapseState] = React.useState<GroupWrapperCollapseState>(GroupWrapperCollapseState.OPEN);
  const [rocketState, setRocketState] = React.useState<boolean>(item.isActive);

  const rocketChange = (state: boolean) => {
    onChange({ ...item, isActive: state });
    setRocketState(state);
  };

  return (
    <Box style={{ backgroundColor: 'white' }}>
      <GroupWrapper
        name="Project Timeline"
        customStyles={!rocketState ? mainStyles.customGroupWrapperStyles : undefined}
        actions={(
          <GroupWrapperFiltersAction
            collapseState={collapseState}
            rocketState={rocketState}
            onRocket={rocketChange}
            onCollapse={(state) => setCollapseState(state)}
          />
        )}
      >
        { collapseState === GroupWrapperCollapseState.OPEN && (
          <>
            <p>
              This section displays information related to the project`s timelines or implementation status, selected from
              the list of specification parameters, specifically from the following two:
              complex.developmentSpecification.completionDates.name & complex.developmentSpecification.constructionPhases.name.
            </p>
            <div className={styles.tileLocationTimelineWrapper}>
              <div className={styles.shortWrapper}>
                <BoxFormTextField
                  label={translations.prefix}
                  name="prefix"
                  defaultValue={item.prefix?.[lang]}
                  onChange={(event) => {
                    onChange(updateTranslatedField(item, 'prefix', lang, event.target.value));
                  }}
                />
              </div>
              <BoxFormAutocomplete
                label={translations.chooseSpecificationProperty}
                name="property"
                defaultValue={{ label: item.property?.translates?.[lang] || item.property?.systemName, value: item.property }}
                onChange={(event: IDevelopmentSpecificationPropChange<IMarketplaceProperty>) => {
                  onChange({ ...item, property: event.value });
                }}
                options={complexPropertyOptions}
              />
              <div className={styles.shortWrapper}>
                <BoxFormTextField
                  label={translations.suffix}
                  name="suffix"
                  defaultValue={item.suffix?.[lang]}
                  onChange={(event) => {
                    onChange(updateTranslatedField(item, 'suffix', lang, event.target.value));
                  }}
                />
              </div>
            </div>
          </>
        ) }
      </GroupWrapper>
    </Box>
  );
};
